import { isWithinReportRange, reportCalendarDay, reportInstant } from '../../../../../utils/dateNumberToMoment';

export const filterList = (
  // Positional API retained for existing report callers.
  // eslint-disable-next-line default-param-last
  data = [],
  filters,
  startDate,
  endDate,
  assocStores,
  dateFilter = 'created_dt',
  associateStoresMap = new Map(),
  // Whether `dateFilter` holds a real instant or a bare calendar date. The caller knows
  // this; the value itself does not, and guessing from its shape is what bucketed clients
  // a day early (ENG-3537).
  dateKind = 'instant',
) => {
  const allStores = assocStores.filter(store => store.id !== 0).map(item => item.id.toString());

  return data?.filter(item => {
    const itemStoreId = item?.store_id?.toString();
    // Reminders carry associate_id = action.updated_by, which stays empty until someone touches
    // the reminder. The report credits those to the client's associate, so the filter has to as
    // well or filtering by an associate drops every open reminder (ENG-3622).
    const itemAssociateId = (item?.associate_id ?? item?.client_associate)?.toString();

    // Filter by store: check if item's store matches selected stores
    const filterStore =
      filters.stores?.length === 0 ? allStores.includes(itemStoreId) : filters.stores.includes(itemStoreId);

    // Filter by associate
    const filterAssociate = filters.associate.length === 0 || filters.associate.includes(itemAssociateId);

    // Additional check: if stores filter is active, ensure the associate has access to those stores
    let filterAssociateHasStoreAccess = true;
    if (filters.stores?.length > 0 && itemAssociateId && associateStoresMap.has(itemAssociateId)) {
      const associateStores = associateStoresMap.get(itemAssociateId);
      filterAssociateHasStoreAccess = filters.stores.some(storeId => associateStores.has(storeId));
    }

    // Filter by date. If the requested field is missing the fallbacks may land on a column
    // of the other kind, so re-derive the kind rather than trusting the caller's tag: while
    // the backend half of ENG-3537 is still rolling out, created_dt is absent and this drops
    // to created_date, a bare UTC day that must not be read as an instant.
    let rawDate = item[dateFilter];
    let rawKind = dateKind;
    if (rawDate === undefined || rawDate === null) {
      rawDate = item?.created_dt ?? item?.created_date ?? item?.due_date;
      if (item?.created_dt === undefined || item?.created_dt === null) rawKind = 'calendar';
    }
    const toFallbackDay = rawKind === 'calendar' ? reportCalendarDay : reportInstant;
    const filterTimeSpan = isWithinReportRange(toFallbackDay(rawDate), startDate, endDate);

    return filterStore && filterAssociate && filterAssociateHasStoreAccess && filterTimeSpan;
  });
};
